<template>
  <div>
    <avue-crud ref="extmenu" :option="option" :data="data"
    @row-save="rowSave"
    @row-update="rowUpdate"
    :before-close="handleBeforeClose">
      <template v-slot:onClickForm="{row, index}">
        <el-select v-model="formOnClick" placeholder="请选择" @change="handleChange(row, index)">
          <el-option
            v-for="item in clickOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template v-slot:onClickLabel="">
        <label class="required">click事件</label>
      </template>
      <template v-slot:menu="{type, size, row, index}">
        <el-button icon="el-icon-edit" :size="size" :type="type" @click.stop="handleEditOpen(row, index)" />
        <el-button icon="el-icon-delete" :size="size" :type="type" @click.stop="rowDel(row, index)" />
      </template>
    </avue-crud>
    <div class="editor" :class="[editorOpen ? 'openeditor' : '']">
      <div class="tool" @click="handleClose">
        <div><i class="el-icon-close" /></div>
      </div>
      <textarea ref="mycode" class="codetext" v-model="code"></textarea>
    </div>
  </div>
</template>

<script>
import mixinCodeMirror from '../../mixins/codeMirror'
export default {
  mixins: [mixinCodeMirror],
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      editorOpen: false,
      formOnClick: 'openURL',
      clickOptions: [
        {
          label: '新窗口打开',
          value: 'openURL'
        },
        {
          label: '执行JS函数',
          value: 'eventName'
        },
        {
          label: '弹出窗口',
          value: 'dialog'
        }
      ],
      option: {
        page: false,
        refreshBtn: false,
        columnBtn: false,
        editBtn: false,
        delBtn: false,
        align: 'center',
        menuAlign: 'center',
        menuWidth: 70,
        column: [
          {
            label: '按钮名称',
            prop: 'name',
            rules: [{
              required: true,
              message: '请输入按钮名称'
            }]
          }, {
            label: '按钮类型',
            prop: 'btnType',
            type: 'select',
            value: 1,
            dicData: [{
              label: '行内',
              value: 1
            }, {
              label: '表头',
              value: 2
            }]
          }, {
            label: '按钮标识',
            prop: 'prop',
            rules: [{
              required: true,
              message: '请输入按钮标识'
            }]
          }, {
            label: 'PC样式',
            prop: 'buttonStyleType',
            type: 'select',
            value: 'text',
            rules: [{
              required: true
            }],
            dicData: [{
              label: '文字按钮',
              value: 'text'
            }, {
              label: '主要按钮',
              value: 'primary'
            }, {
              label: '成功按钮',
              value: 'success'
            }, {
              label: '信息按钮',
              value: 'info'
            }, {
              label: '警告按钮',
              value: 'warning'
            }, {
              label: '危险按钮',
              value: 'danger'
            }]
          }, {
            label: '按钮icon',
            prop: 'icon'
          }, {
            label: 'click事件',
            prop: 'onClick',
            formslot: true,
            labelslot: true
          }, {
            label: '查看显示',
            prop: 'viewPageShow',
            type: 'select',
            value: true,
            dicData: [{
              label: '是',
              value: true
            }, {
              label: '否',
              value: false
            }]
          }, {
            label: '新窗口打开',
            prop: 'openURL',
            span: 24,
            display: true,
            placeholder: '如：http://www.wiseloong.com?id=${id}&processCode=${main.processCode}',
            hide: true
          }, {
            label: '执行JS函数',
            prop: 'eventName',
            span: 24,
            hide: true,
            display: false,
            type: 'textarea'
          }, {
            label: 'iframe地址',
            prop: 'iframeURL',
            span: 24,
            hide: true,
            placeholder: '如：http://www.wiseloong.com?id=${id}&processCode=${main.processCode}',
            display: false
          }, {
            label: '是否全屏',
            prop: 'fullscreen',
            type: 'select',
            value: true,
            display: false,
            hide: true,
            dicData: [{
              label: '是',
              value: true
            }, {
              label: '否',
              value: false
            }]
          }, {
            label: '弹框宽度',
            prop: 'width',
            display: false,
            hide: true
          }, {
            label: '弹框高度',
            prop: 'height',
            display: false,
            placeholder: '案例：100vh 或700px'

          }, {
            label: '确认按钮',
            prop: 'confirmName',
            display: false,
            hide: true
          }, {
            label: '取消按钮',
            prop: 'cancelName',
            display: false,
            hide: true
          }
        ]
      }
    }
  },
  computed: {
    data: function() {
      return this.datas
    }
  },
  watch: {
    formOnClick: {
      handler(val) {
        switch (val) {
          case 'openURL': {
            this.setDisplay(6, true)
            this.editorOpen = false
            break
          }
          case 'eventName': {
            this.setDisplay(6, false)
            this.editorOpen = true
            break
          }
          case 'dialog': {
            this.setDisplay(6, false, true)
            this.editorOpen = false
          }
        }
      }
    }
  },
  methods: {
    rowSave(form, done, loading) {
      form.onClick = this.formOnClick
      form.eventName = this.code
      done(form)
      this.formOnClick = 'openURL'
      this.$emit('on-data', this.data)
    },
    handleEditOpen(row, index) {
      this.formOnClick = row.onClick
      if (row.onClick === 'eventName') {
        this.codeSetVal(row)
        this.editorOpen = true
      }
      this.$refs.extmenu.rowEdit(row, index)
    },
    rowDel(form, index) {
      this.datas.splice(index, 1)
    },
    rowUpdate(form, index, done, loading) {
      form.onClick = this.formOnClick
      form.eventName = this.code
      this.editorOpen = false
      this.$set(this.datas, index, form)
      this.$emit('on-data', this.datas)
      done()
    },
    handleChange(row, index) {
      row.onClick = this.formOnClick
      this.codeSetVal(row)
    },
    handleClose() {
      this.editorOpen = false
    },
    handleBeforeClose(done, type) {
      this.formOnClick = 'openURL'
      this.editorOpen = false
      done()
    },
    setDisplay(i, val, val2 = false) {
      this.option.column[i].display = true
      // this.option.column[6].display = true
      this.option.column[7].display = val
      this.option.column[8].display = false
      this.option.column[9].display = val2
      this.option.column[10].display = val2
      this.option.column[11].display = val2
      this.option.column[12].display = val2
      this.option.column[13].display = val2
      this.option.column[14].display = val2
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/extBtn.scss';
</style>

